import React from 'react';
import { string, number, oneOfType, bool } from 'prop-types';
import { Icon, Row, Column } from 'app-components/common';
import Text from '../Text';

const StatInfo = ({ label, value, icon, color, labelColor, labelSize, size, semibold }) => {
    const fontWeight = semibold ? { semibold } : { strong: true };
    return (
        <Column>
            <Row align='center' justify='center'>
                <Icon name={icon} color={color} />
                <Text text={`${value}`} color={color} strong size={size} />
            </Row>
            <Row justify='center'>
                <Text text={label} color={labelColor} size={labelSize} {...fontWeight} />
            </Row>
        </Column>
    );
};

StatInfo.propTypes = {
  label: string,
  value: oneOfType([string, number]),
  icon: string,
  color: string,
  labelColor: string,
  labelSize: number,
  size: number,
  semibold: bool
};

StatInfo.defaultProps = {
  label: '',
  value: 0,
  icon: '',
  color: '#333333',
  labelColor: '#333333',
  labelSize: 8,
  semibold: false
};

export default StatInfo;
